import React from "react";

// Brand mark: the PT Tracker patch on signal-orange. The image is full-bleed
// orange, so it sits seamlessly in the orange box; the bg shows while it loads.
export default function Logo({ size = 40, className = "" }) {
  return (
    <img
      src="./logo.png"
      width={size}
      height={size}
      alt="PT Tracker"
      className={`bg-signal shrink-0 object-cover ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
